export function formatCurrency(amount) {
  const n = Number(amount) || 0;
  const neg = n < 0;
  const abs = Math.abs(n);
  const [intp, decp] = abs.toFixed(2).split(".");
  // Indian grouping
  let s = intp;
  if (s.length > 3) {
    const head = s.slice(0, -3);
    const tail = s.slice(-3);
    s = head.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + tail;
  }
  return `${neg ? "-" : ""}₹${s}.${decp}`;
}

export function formatDateDDMMYYYY(d) {
  const dt = typeof d === "string" ? new Date(d) : d;
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const yyyy = dt.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

export function isoDate(d) {
  const dt = d || new Date();
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const day = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export const MONTH_NAMES = ["", "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];
